var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-btn"},[_c('i',{staticClass:"budicon-solid budicon-solid-trash"}),_c('span',[_vm._v("Slett")])])
}]

export { render, staticRenderFns }